import { Radio, RadioGroup, Title } from '@panwds/react-ui'
import type { VFC } from 'react'
import { actions } from '@sparky/framework'
import type { ThemePreferenceValue } from '@sparky/framework/build/types/framework/stateTypes'

const Preferences: VFC<{theme: string | undefined}> = ({ theme }) => {
  return (
    <div className='tw-w-64 tw-flex tw-flex-col tw-m-8 tw-p-4 cm-bg-gray-200 dark:cm-bg-gray-1000'>
      <Title level={2} size='xs' addClassName='tw-mb-2'>Light/Dark Mode</Title>
      <Title level={2} size='xxs' addClassName='tw-mb-2'>Choose your display mode:</Title>
      <RadioGroup
        name='gender'
        value={theme}
        onChange={(event) => {
          actions.setUserTheme(event.target.value as ThemePreferenceValue)
        }}
      >
        <Radio value='dark'>Dark</Radio>
        <Radio value='light'>Light</Radio>
        <Radio value='system'>Follow System Settings</Radio>
      </RadioGroup>
    </div>
  )
}

export default Preferences
